import type { AdditionalServices } from '@src/@types/microcredits';

export const getAdditionalConditionsCardText = (additionalServices: Pick<AdditionalServices, 'list' | 'exist'>) => {
  if (additionalServices?.exist) {
    return additionalServices?.list.length > 0 ? 'Есть' : 'Неизвестно';
  }

  return 'Нет';
};
